import {styled} from '@mui/material/styles'
import {Box, Tabs, Tab, Divider} from '@mui/material'

export const TabsContainer = styled(Box)(({theme}) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper
}))

export const StyledTabs = styled(Tabs)(({theme}) => ({
  minHeight: 48,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3
  },
  '& .MuiTabs-scrollButtons': {
    width: 24,
    height: 24,
    margin: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    borderRadius: '50%',
    border: '1px solid',
    borderColor: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.selected
    },
    '&.Mui-disabled': {
      display: 'none'
    }
  }
}))

export const StyledTab = styled(Tab)(({theme}) => ({
  textTransform: 'none',
  minWidth: 'auto',
  minHeight: 48,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.secondary,
  padding: theme.spacing(1, 1),
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold
  },
  '&:hover': {
    color: theme.palette.primary.main,
    opacity: 1
  }
}))

export const TabPanelContainer = styled(Box)(({theme}) => ({
  flexGrow: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0
}))

export const FilterContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1)
}))
export const FilterItemContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}))

export const EmptyState = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  color: theme.palette.text.secondary
}))

export const StyledCategoryDivider = styled(Divider)(({theme}) => ({
  marginTop: theme.spacing(1),
  borderColor: theme.palette.hpBaseLighter
}))
